import { API_BASE, UPLOADS_BASE } from './config';
import defaultProductImage from '../assets/images/Bizaario-Store-1.jpg';

export { UPLOADS_BASE };

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return response.json();
}

export async function fetchProducts() {
  const data = await fetchJson(`${API_BASE}/master/products`);
  return Array.isArray(data) ? data : [];
}

export async function fetchProductCategories() {
  const data = await fetchJson(`${API_BASE}/master/product-categories`);
  return Array.isArray(data) ? data : [];
}

export async function fetchProductsForDisplay() {
  return fetchProducts();
}

export const slugifyProductName = (text, id) => {
  const base = String(text || 'product')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return base ? `${base}-${id}` : `product-${id}`;
};

export function getProductIdFromSlug(slug) {
  const raw = String(slug || '');
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = raw.match(/-(\d+)$/);
  return match ? Number(match[1]) : null;
}

function mapProductImages(product) {
  return (product.product_images || [])
    .map((img) => `${UPLOADS_BASE}/uploads/${img.image_path}`)
    .filter(Boolean);
}

export function mapProductToCardProps(product) {
  const uploadedImages = mapProductImages(product);
  const id = product.product_id;

  return {
    id,
    slug: slugifyProductName(product.product_name, id),
    categoryId: product.product_category_id,
    categoryName: product.product_category || '',
    image: uploadedImages[0] || defaultProductImage,
    title: product.product_name || '',
    description: product.short_description || product.long_description || '',
  };
}

export function mapProductToDetailProps(product) {
  const uploadedImages = mapProductImages(product);
  const id = product.product_id;
  const images = uploadedImages.length ? uploadedImages : [defaultProductImage];

  return {
    id,
    slug: slugifyProductName(product.product_name, id),
    categoryId: product.product_category_id,
    categoryName: product.product_category || '',
    subCategoryName: product.product_sub_category || '',
    images,
    image: images[0],
    title: product.product_name || '',
    shortDescription: product.short_description || '',
    longDescription: product.long_description || '',
    description: product.short_description || product.long_description || '',
    videoUrl: product.product_video_url || '',
    profilePdf: product.product_profile_pdf_path
      ? `${UPLOADS_BASE}/uploads/${product.product_profile_pdf_path}`
      : '',
    comments: product.comments || '',
  };
}
